module.exports = __webpack_public_path__ + "img/77.6fcc6845.webp";